import Article from "./Article";

import { connect } from "react-redux";

import { fetchArticle } from "reduxCode/actions/articles";
import { getArticle } from "reduxCode/selectors/articles";
import { getErrors } from "reduxCode/selectors/error";

import "./article.scss";

const mapStateToProps = (state, ownProps) => {
  return {
    errors: getErrors(state)["single-article"],
    article: getArticle(state, ownProps.id) || {}
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchArticle: (id) => {
      dispatch(fetchArticle(id));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Article);
 